/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, SCS) {
	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */
	/**
	 * Subtotal module implementation.
	 *
	 * @author Stefan Maurer, Cesar Keller
	 * @namespace Tc.Module
	 * @class Subtotal
	 * @extends Tc.Module
	 */
	Tc.Module.Subtotal = Tc.Module.extend({

		EVT_STEP_LOADED: 'steploaded',
		EVT_BEFORE_NEXT_STEP: 'beforenextstep',
		EVT_BEFORE_PREVIOUS_STEP: 'beforepreviousstep',
		step: [], // step[id] = stepUrl

		/**
		 * Main hook.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this,
				scrollTop = 0,
				$window = $(window),
				scrollThreshold = mod.$ctx.offset().top;

			// fixed subtotal box if it scrolls out of the viewport
			$window.scroll(function () {

				// only fix box if it at least fits the window
				if (mod.$ctx.height() <= window.innerHeight && !$(document.body).hasClass('cq_isEditMode')) {
					scrollTop = $window.scrollTop();
					if (mod.$ctx.hasClass('sdxStyle') && scrollTop <= 0) {
						mod.$ctx.removeClass('is-fixed');
						return;
					}
					else if (scrollTop >= scrollThreshold) {
						mod.$ctx.addClass('is-fixed');
					} else if (scrollTop < scrollThreshold) {
						mod.$ctx.removeClass('is-fixed');
					}
				} else {
					mod.$ctx.removeClass('is-fixed');
				}
			});

			if(mod.$ctx.hasClass('sdxStyle')) {
				$('.modSharedHeader, .modHeader, .scs-pageheader').addClass('spacer');
				if(SCS.utils.isMobilePage()) {
					$('.stageMobile').css('position', 'initial');
				}
				mod.$ctx.find('i.icon, button.close').on('click', function() {
					mod.$ctx.toggleClass('showDetails');
				});
			}

			mod.updateSubtotalSum();
			mod.bindEvents();
			mod.showOrHideDetails();
			callback();
		},

		after: function () {
			var mod = this;

			mod.bindEvents();
		},

		onPriceAdded: function () {
			var mod = this;

			mod.updateSubtotalSum();
			mod.bindEvents();
		},

		bindEvents: function () {
			var mod = this,
				$form = $('.modScForm'); // not a parent or child of this mod

			// ensure events are only bound once
			var changeHandler = function () {
				mod.updateSubtotalSum(mod);
			};

			$form.find(':input[data-price],:input[data-onetime-charge],:input[data-type=item]')
				.off('change', changeHandler)
				.on('change', changeHandler);

			// Find sdx input elements and register click
			$form
				.find('sdx-input-item')
				.each(function(_index, el) {
					el.changeCallback = mod.updateSubtotalSum.bind(mod, mod);
				});

			var nextHandler = function (e, stepUrl, stepId) {
				mod.showOrHide(stepUrl, stepId);
			};

			var previousHandler = function (e, stepId) {
				mod.showOrHide(null, stepId);
			};

			$form
				.off(mod.EVT_STEP_LOADED, nextHandler)
				.on(mod.EVT_STEP_LOADED, nextHandler)
				.off(mod.EVT_BEFORE_NEXT_STEP, nextHandler)
				.on(mod.EVT_BEFORE_NEXT_STEP, nextHandler)
				.off(mod.EVT_BEFORE_PREVIOUS_STEP, previousHandler)
				.on(mod.EVT_BEFORE_PREVIOUS_STEP, previousHandler);
		},

		showOrHide: function (stepUrl, stepId) {
			var mod = this,
				$ctx = mod.$ctx,
				hideOnPages = $ctx.data('hide-on-pages'),
				separators = '(,|])';

			if (stepUrl) {
				mod.step[stepId] = stepUrl;
			} else {
				stepUrl = mod.step[stepId];
			}

			if (typeof hideOnPages === 'string' && hideOnPages.match(stepUrl + separators)) {
				$ctx.hide();
			} else {
				$ctx.show();
			}
		},

		showOrHideDetails: function () {
			var mod = this,
				$ctx = mod.$ctx,
				togglers = $ctx.find('div.toggle-on-details, div.toggle-off-details');

			togglers.on('click', 'span, .arrow-down, .arrow-up', function (e) {
				e.preventDefault();

				togglers.toggle();
				$ctx.find('div.section-details').slideToggle(200);
			});
		},

		updateSubtotalSum: function (module) {
			var mod = module || this,
				$ctx = mod.$ctx,
				$form = $('.modScForm form'), // not a parent or child of this mod
				subtotal = 0,
				subtotalElement = $ctx.find('.subtotal'),
				priceElement = subtotalElement.find('.price'),
				priceOTCElement = subtotalElement.find('.priceOTC'),
				itemPriceElement = $ctx.find('span.items-total-monthly-price'),
				itemPriceOTCElement = $ctx.find('span.items-total-onetime-price'),
				subtotalOTC = 0;

			// remove current content
			$ctx.find('ul.items li').remove();

			// add base and items
			$form.find(':input[data-price],.modBaseBundleOption :input[data-hascost], sdx-input-item[data-price],.modBaseBundleOption sdx-input-item[data-hascost]').each(function () {
				var $this = $(this),
					amount = ($this.filter('[data-hascost]').length && $this.data('hascost') !== '') ? $this.data('hascost') : $this.val(),
					itemPrice = amount * $this.data('price'),
					itemPriceFormatted = parseFloat(Math.round(itemPrice * 100) / 100).toFixed(2),
					itemMarkup = '<li><dl><dt>',
					isCheckboxOrRadio = ['checkbox', 'radio'].indexOf(this.type) > -1,
					itemLabel = $this.data('label'),
					summary = $this.data('summary') || '';

				if (amount > 0) {
					var isUncheckedRadioOrCheckbox = isCheckboxOrRadio && !$this.prop('checked');
					if($this.is('sdx-input-item:not(.hydrated)')) {
						isUncheckedRadioOrCheckbox = !$this.attr('checked');
					}
					if (isUncheckedRadioOrCheckbox) {
						return;
					}

					if ($this.data('price').length === 0) {
						return;
					}

					if (amount > 1) {
						itemMarkup += amount + ' x ';
					}

					itemMarkup += itemLabel;

					if (summary.length > 0 && !$ctx.hasClass('sdxStyle')) {
						itemMarkup += '<br />' + summary;
					}
					else {
						itemMarkup += ' ' + summary;
					}

					itemMarkup += '</dt><dd>';

					if (isNaN(itemPrice)) {
						itemPrice = 0;
					} else {
						if (itemPrice !== 0) {
							itemMarkup += itemPriceFormatted;
						}
					}

					itemMarkup += '</dd></dl></li>';

					$ctx.find('.monthly-items').children('.items').append(itemMarkup);
					subtotal += itemPrice;
				}
			});

			// remove current content
			$ctx.find('ul.one-time-items li').remove();
			$ctx.find('.one-time-items').addClass('ui-helper-hidden');

			// add base and items
			$form.find(':input[data-onetime-charge], sdx-input-item[data-onetime-charge]').each(function () {
				var $this = $(this),
					amount = ($this.filter('[data-hascost]').length && $this.data('hascost') !== '') ? $this.data('hascost') : $this.val(),
					itemPriceOTC = amount * $this.data('onetime-charge'),
					itemPriceOTCFormatted = parseFloat(Math.round(itemPriceOTC * 100) / 100).toFixed(2),
					itemMarkup = '<li><dl><dt>',
					isCheckboxOrRadio = ['checkbox', 'radio'].indexOf(this.type) > -1,
					itemLabel = $this.data('label'),
					summary = $this.data('summary') || '';

				if (amount > 0) {
					var isUncheckedRadioOrCheckbox = isCheckboxOrRadio && !$this.prop('checked');
					if($this.is('sdx-input-item:not(.hydrated)')) {
						isUncheckedRadioOrCheckbox = !$this.attr('checked');
					}
					if (isUncheckedRadioOrCheckbox) {
						return;
					}

					if ($this.data('onetime-charge').length === 0) {
						return;
					}

					if (amount > 1) {
						itemMarkup += amount + ' x ';
					}

					itemMarkup += itemLabel;

					if (summary.length > 0) {
						itemMarkup += '<br />' + summary;
					}

					itemMarkup += '</dt><dd>';

					if (isNaN(itemPriceOTC)) {
						itemPriceOTC = 0;
					} else {
						if (itemPriceOTC !== 0) {
							itemMarkup += itemPriceOTCFormatted;
						}
						else if (itemPriceOTC === 0 && mod.$ctx.hasClass('sdxStyle')) {
							itemMarkup += '0.00';
						}
					}

					itemMarkup += '</dd></dl></li>';

					$ctx.children('.itemsOTC').append(itemMarkup);
					subtotalOTC += itemPriceOTC;
					$ctx.find('.one-time-items').removeClass('ui-helper-hidden');
					$ctx.find('.one-time-items > .items').append(itemMarkup);
				}
			});

			// calculate and display subtotal
			subtotal = parseFloat(Math.round(subtotal * 100) / 100).toFixed(2);
			subtotalOTC = parseFloat(Math.round(subtotalOTC * 100) / 100).toFixed(2);
			priceElement.html(subtotal);
			itemPriceElement.html(subtotal);
			priceOTCElement.html(subtotalOTC);
			itemPriceOTCElement.html(subtotalOTC);

			// change font size of prices, depending on the width
			if (priceElement.text().length > 5 || priceOTCElement.text().length > 5) {
				subtotalElement.addClass('medium');
			} else {
				subtotalElement.removeClass('medium');
			}
		}
	});
})(Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.Subtotal.js
// module id = 258
// module chunks = 0